<template>
  <v-app id="app">
    <v-main>
      <template v-if="$settings?.system?.status === 'suspended'">
        <v-container justify-center fill-height>
          <div
            class="d-flex flex-column fill-height justify-center align-center text-center"
          >
            <v-icon size="4rem" color="green accent-4" class="mb-4">
              mdi-rocket-launch
            </v-icon>

            <h1 class="text-h5 font-weight-bold mb-3">
              Estamos preparando uma nova versão
            </h1>

            <p
              class="text-body-1 text--secondary mb-6"
              style="max-width: 37.5rem"
            >
              {{ $settings.system.message }}
            </p>

            <v-alert
              type="warning"
              outlined
              border="left"
              class="mt-4"
              style="max-width: 40rem"
            >
              <div class="text-body-2">
                <strong>Aviso de segurança</strong><br />
                O único site oficial do <strong>Palavra Premiada</strong> é
                <strong>https://palavrapremiada.com</strong>.<br />
                Qualquer outro domínio ou site semelhante
                <strong>não é autorizado</strong> e pode representar
                <strong>tentativa de cópia ou golpe</strong>. Utilize apenas o
                endereço oficial para sua segurança.
              </div>
            </v-alert>
          </div>
        </v-container>
      </template>

      <SplashScreen v-else-if="loading" />

      <template v-else>
        <router-view class="mb-8" />
      </template>
    </v-main>

    <AlertBar ref="alertBar" />
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import { loadSession } from "@/services/auth";
import SplashScreen from "@/components/splashScreen/SplashScreen";
import AlertBar from "@/components/alertBar/AlertBar";

export default {
  name: "App",

  components: {
    SplashScreen,
    AlertBar,
  },

  data() {
    return {
      loading: true,
    };
  },

  created() {
    this.initTheme();
    this.handleSession();
  },

  beforeMount() {
    this.$root.$on("alert", this.handleAlert);
    this.$root.$on("sign-out", this.signOut);
    this.$root.$on("load-session", this.handleSession);

    console.log("NODE_ENV:", process.env.NODE_ENV);
  },

  mounted() {
    this.setCrispSettings();
  },

  beforeDestroy() {
    this.$root.$off("alert", this.handleAlert);
    this.$root.$off("sign-out", this.signOut);
    this.$root.$off("load-session", this.handleSession);
  },

  methods: {
    ...mapActions(["setUser", "setSignOut"]),

    async handleSession() {
      const token = this.$store.getters.accessToken;

      if (token) {
        try {
          const { data } = await loadSession();
          this.setUser(data);
        } catch {
          this.signOut();
        }
      }

      this.loading = false;
    },

    async signOut() {
      try {
        this.loading = true;
        await this.$socket.disconnect();
        await this.setSignOut();

        if (this.$route.name !== "SignIn")
          this.$router.push({ name: "SignIn" });
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },

    initTheme() {
      Object.entries(this.$settings?.colorPalette).forEach(([key, value]) => {
        if (
          this.$vuetify.theme.themes.dark &&
          this.$vuetify.theme.themes.dark[key] !== undefined
        )
          this.$vuetify.theme.themes.dark[key] = value;

        if (
          this.$vuetify.theme.themes.white &&
          this.$vuetify.theme.themes.white[key] !== undefined
        )
          this.$vuetify.theme.themes.white[key] = value;
      });
    },

    setCrispSettings() {
      const resizeCrispBubble = () => {
        // container raiz do Crisp
        const content = document.querySelector(".crisp-client");
        if (content) {
          content.style.setProperty("z-index", "4", "important");
        }

        const bubbleWrapper = document.querySelector(
          '.crisp-client #crisp-chatbox[data-full-view="true"] .cc-1qbp0.cc-1o31k'
        );

        if (bubbleWrapper) {
          bubbleWrapper.setAttribute(
            "style",
            `
              width: 40px !important;
              height: 40px !important;
              min-width: 40px !important;
              min-height: 40px !important;
              max-width: 40px !important;
              max-height: 40px !important;
              border-radius: 40px !important;
            `
          );
        }

        // bolha do chat (baseado em data-id e data-is-ongoing)
        const bubble = document.querySelector(
          '.crisp-client #crisp-chatbox[data-full-view="true"] [data-id="chat_closed"][data-is-ongoing="false"]'
        );

        // ícone dentro da bolha (primeiro filho do bubble)
        if (bubble?.firstElementChild) {
          const icon = bubble.firstElementChild;
          icon.style.setProperty("width", "24px", "important");
          icon.style.setProperty("height", "24px", "important");
          icon.style.setProperty("top", "9px", "important");
          icon.style.setProperty("left", "8px", "important");
        }

        // container da bolha (o button que envolve tudo)
        const container = document.querySelector(
          '.crisp-client #crisp-chatbox[data-full-view="true"] [role="button"][data-maximized="false"]'
        );
        if (container) {
          container.style.setProperty("bottom", "8px", "important");
          container.style.setProperty("right", "8px", "important");
        }
      };

      // garante que aplica até o Crisp terminar de montar
      const interval = setInterval(() => {
        resizeCrispBubble();

        if (
          document.querySelector(
            '.crisp-client #crisp-chatbox[data-full-view="true"] [data-id="chat_closed"]'
          )
        ) {
          clearInterval(interval);
        }
      }, 500);
    },

    toggleCrisp(visible) {
      if (!window.$crisp) return;

      if (visible) {
        window.$crisp.push(["do", "chat:show"]);
      } else {
        window.$crisp.push(["do", "chat:hide"]);
      }
    },

    handleAlert(event) {
      this.$refs.alertBar.handleAlert(event);
    },
  },
};
</script>

<style lang="scss">
html {
  background: $neutral;
}

#app {
  background: $neutral;
}
</style>
